import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col } from 'antd';
import CardSection from '../../../components/section/CardSection';
import { AppRoute } from '../../../routes';
import { Link } from 'react-router-dom';

type SqliteHomeProps = {};

const SqliteHome: React.FC<SqliteHomeProps> = () => {
  return (
    <>
      <Link to={AppRoute.SQLITE}>
        <CardSection height={134} backgroundColor="#1890FF10" marginBottom={0} hoverable={true}>
          <Col style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <FontAwesomeIcon icon="database" style={{ width: 20, height: 20 }} />
            <h3 style={{ fontSize: 16, margin: 0, marginTop: 10, textAlign: 'center' }}>My sqlite data storage</h3>
          </Col>
        </CardSection>
      </Link>
    </>
  );
};

export default SqliteHome;
